<script lang="ts" setup></script>

<template>
  <div :class="$style.container">
    <p :class="[$style.container__title, $style.title]">
      <slot name="heading" />
    </p>
    <div :class="[$style.container__cardList, $style.cardList]">
      <slot />
    </div>
  </div>
</template>

<style lang="scss" module>
@use '../_constants.scss' as *;
.container {
  max-width: $content-width;
  padding: 0 16px;
}

.title {
  text-align: center;
  font-size: 36px;
  font-weight: bold;
  line-height: 50.4px;

  @include mobile-only {
    font-size: 24px;
    line-height: 33.6px;
  }
}

.cardList {
  display: flex;
  justify-content: center;
  gap: 32px;
  margin-top: 40px;

  @include mobile-only {
    flex-direction: column;
    align-items: center;
    gap: 16px;
    margin-top: 32px;
  }
}
</style>
